import { createFileRoute } from '@tanstack/react-router'

import CustomerBookTablePage from '@/views/o2o/customer-book-table/customer-book-table.page'

export const Route = createFileRoute('/_layout/o2o/customer-book-table')({
  component: CustomerBookTablePage,
})
